import { generatePath } from "react-router";

interface RouteParams {
  [key: string]: string | number;
}

const generateRoute = (route: string) => {
  return (params?: RouteParams) => {
    if (!params) return route;
    return generatePath(route, params);
  };
};

function getObjectId(name: string): string {
  return `:${name}`;
}

const PARAM_ENTITY = {
  STASH: getObjectId("stashId"),
  LINK: getObjectId("linkId"),
  ENTITY: getObjectId("entityId"),
  VENUE: getObjectId("venueId"),
  EVENT: getObjectId("eventId"),
  NODE: getObjectId("id"),
};

/**************************************************************************************
 ******************* INTERNAL ROUTES ****************************************************
 **************************************************************************************/

export const DEBUG = generateRoute("/debug");

/**************************************************************************************
 ******************* PUBLIC ROUTES ****************************************************
 **************************************************************************************/

export const ROOT = generateRoute("/");
export const LANDING_PAGE = generateRoute("/web-landing");
export const LOGIN = generateRoute("/login");
export const SIGNUP = generateRoute("/signup");
export const INVITE_LANDING = generateRoute("/i/:code");
export const MOBILE_APP_LANDING = generateRoute("/mobile-app-landing");
export const GETTING_STARTED_SETUP = generateRoute("/getting-started/setup");
export const FAQ = generateRoute("/faq");
export const TERMS = generateRoute("/terms");
export const PRIVACY = generateRoute("/privacy");
export const CHATGPT_CONNECT = generateRoute("/connect/chatgpt");
export const CHATGPT_CONNECTIONS = generateRoute("/connections/chatgpt");
export const HELP = generateRoute("/help");
export const RESET = generateRoute("/reset");
export const RESET_PASSWORD = generateRoute("/reset-password/:token");
export const VERIFY_EMAIL = generateRoute("/verify-email");
export const UNSUBSCRIBE = generateRoute("/unsubscribe");
export const DECK = generateRoute("/deck/:version");

// Marketing / content pages (public, prerendered for search + AI crawlers)
export const BLOG = generateRoute("/blog");
export const BLOG_POST = generateRoute("/blog/:slug");
export const BLOG_CATEGORY = generateRoute("/blog/category/:categorySlug");
export const APP_TO_SAVE_ORGANIZE_SOCIAL_POSTS = generateRoute("/app-to-save-and-organize-social-media-posts");
export const SAVE_PLACES_FROM_TIKTOK = generateRoute("/save-places-from-tiktok");
export const ORGANIZE_SAVED_REELS = generateRoute("/organize-saved-reels");
export const SAVE_TIKTOKS = generateRoute("/save-tiktoks");
export const SAVE_RECIPES_FROM_INSTAGRAM_TIKTOK = generateRoute("/save-recipes-from-instagram-and-tiktok");
export const SAVE_TRAVEL_IDEAS_FROM_INSTAGRAM_TIKTOK = generateRoute("/save-travel-ideas-from-instagram-and-tiktok");
export const SAVE_EVENTS_FROM_INSTAGRAM_TIKTOK = generateRoute("/save-events-from-instagram-and-tiktok");
export const SAVE_GIFT_IDEAS_FROM_SOCIAL_MEDIA = generateRoute("/save-gift-ideas-from-social-media");
export const RECIME_ALTERNATIVE = generateRoute("/recime-alternative");
export const STACKLIST_ALTERNATIVE = generateRoute("/stacklist-alternative");
export const COMPARE = generateRoute("/compare");

/**************************************************************************************
 ******************* COMMON ROUTES ****************************************************
 **************************************************************************************/

export const ACTIVATE = generateRoute("/activate");
export const ONBOARDING = generateRoute("/onboarding");
export const NOT_FOUND = generateRoute("*");

/**************************************************************************************
 ******************* AUTHENTICATED ROUTES ****************************************************
 **************************************************************************************/

export const HOME = generateRoute("/home");

export const STASHES = generateRoute("/stashes");

export const COLLECTIONS = generateRoute("/collections");

// The user's own "Favourites" and "Done" collections, and their tags (native parity).
export const FAVORITES = generateRoute("/favorites");
export const DONE = generateRoute("/done");
export const TAGS = generateRoute("/tags");

export const EVENTS = generateRoute("/events");

export const MAP = generateRoute("/map");

export const DISCOVER = generateRoute("/discover");
export const EXPLORE = generateRoute("/explore");

export const CHAT = generateRoute("/chat");
export const STASHT_CHAT = generateRoute("/stashtchat");

export const SEARCH = generateRoute("/search");

export const PROFILE = generateRoute("/profile");

export const SETUP = generateRoute("/setup");
export const BASICS = generateRoute("/basics");

export const EDIT_PROFILE = generateRoute("/profile/edit");

export const ACCOUNT_SETTINGS = generateRoute("/profile/settings");

export const DELETE_ACCOUNT = generateRoute("/profile/delete");

export const NOTIFICATION_SETTINGS = generateRoute("/profile/notification-settings");

// Settings › Home, menu and start (native HomeLayoutEditor).
export const HOME_LAYOUT = generateRoute("/profile/home-layout");

export const NOTIFICATIONS = generateRoute("/profile/notifications");

export const ROUNDUPS = generateRoute("/profile/roundups");
export const ROUNDUP_DETAIL = generateRoute(`/profile/roundups/${getObjectId("roundupId")}`);

export const QR_LOGIN_SCANNER = generateRoute("/qr-login-scanner");
export const QR_LOGIN_CONFIRM = generateRoute("/qr-login-confirm");
export const QR_SCANNER = generateRoute("/scan");

export const INVITE_QR = generateRoute("/invite");

export const STASH_DETAIL = generateRoute(`/stash/${PARAM_ENTITY.STASH}`);
export const STASH_TAG_BROWSE = generateRoute(`/stash/${PARAM_ENTITY.STASH}/tags`);

export const STUFF_DETAIL = generateRoute(`/stuff/${PARAM_ENTITY.ENTITY}`);

export const COLLECTION_DETAIL = generateRoute(`/collections/${getObjectId("collectionId")}`);

export const CAMPAIGN_LANDING = generateRoute(`/campaign/${getObjectId("campaignId")}`);
